import { makeBetterEnum } from './betterEnum';

export const TimeseriesFrequency = makeBetterEnum('Monthly', 'Yearly');

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TimeseriesFrequency =
  (typeof TimeseriesFrequency)[keyof typeof TimeseriesFrequency];
